// ====================================
// IndustryExploration.jsx
// ====================================
import React from 'react';

const IndustryExploration = () => {
const industries = [
{ name: 'Technology', growth: 'High', icon: '💻' },
{ name: 'Healthcare', growth: 'High', icon: '🏥' },
{ name: 'Finance', growth: 'Medium', icon: '💰' },
{ name: 'Education', growth: 'Medium', icon: '📚' },
];

return (
<div className="bg-card border border-border rounded-lg p-6">
<h3 className="text-lg font-semibold text-text-primary mb-4">Industry Insights</h3>
<div className="grid grid-cols-2 md:grid-cols-4 gap-4">
{industries.map(industry => (
<div key={industry.name} className="text-center p-4 bg-muted rounded-lg">
<div className="text-3xl mb-2">{industry.icon}</div>
<p className="text-sm font-medium text-text-primary">{industry.name}</p>
<p className="text-xs text-text-secondary">{industry.growth} Growth</p>
</div>
))}
</div>
</div>
);
};

export default IndustryExploration;